import { AccountService } from "@gtmhub/accounts/accountsService";
import { FeatureToggleV2Service } from "@gtmhub/featureToggle";
import { FeatureFlag } from "@gtmhub/featureToggle/models";
import { IComponentOptions, IQService } from "angular";

export class NavigationWrapperCtrl {
  static $inject = ["FeatureToggleV2Service", "AccountService", "$q"];
  showNewExperience: boolean;
  checkingEnabledFeatures: boolean;

  constructor(private featureToggleService: FeatureToggleV2Service, private accountService: AccountService, private $q: IQService) {}

  $onInit(): void {
    this.checkingEnabledFeatures = true;
    const promises = {
      newExperienceEnabled: this.featureToggleService.isFeatureAvailable(FeatureFlag.NewExperience),
      newExperienceToggleEnabled: this.featureToggleService.isFeatureAvailable(FeatureFlag.NewExperienceToggle),
    };

    this.$q
      .all(promises)
      .then(({ newExperienceEnabled, newExperienceToggleEnabled }) => {
        const newExperienceAccountSettingEnabled = this.accountService.getAccountSetting<Record<"enabled", boolean>>("newExperience")?.enabled;
        this.showNewExperience = newExperienceEnabled && newExperienceToggleEnabled && newExperienceAccountSettingEnabled;
        this.checkingEnabledFeatures = false;
      })
      .catch(() => (this.checkingEnabledFeatures = false));
  }
}

export const NavigationWrapperComponent: IComponentOptions = {
  controller: NavigationWrapperCtrl,
  templateUrl: require("./navigation-wrapper.jade"),
  bindings: {},
};
